import Empty from './src'

Empty.install = Vue => {
  Vue.component(Empty.name, Empty)
}

export default Empty
